import request from '../../utils/request'

export function getSysUserList(data) {
  return request({
    url: '/sysUser/page',
    method: 'post',
    data
  })
}

export function insSysUserInfo(data) {
  return request({
    url: '/sysUser/',
    method: 'post',
    data: data
  })
}

export function updSysUserInfo(data) {
  return request({
    url: '/sysUser/updateUser',
    method: 'put',
    data: data
  })
}

export function frozenSysUser(userId) {
  return request({
    url: '/sysUser/frozen/' + userId,
    method: 'put'
  })
}

export function resumeSysUser(userId) {
  return request({
    url: '/sysUser/resume/' + userId,
    method: 'put'
  })
}

export function delSysUserInfo(id) {
  return request({
    url: '/sysUser/' + id,
    method: 'delete',
  })
}

export function accountCount(typeData,id) {
  const data = {
    'userAccount': typeData,
    'id': id
  }
  if(id == null){
    data.id = ''
  }
  return request({
    url: '/sysUser/accountCount',
    method: 'get',
    params: data
  })
}

export function resetUserPassword(userId) {
  return request({
    url: '/sysUser/resetUserPassword/' + userId,
    method: 'put'
  })
}

export function updatePassword(data) {
  return request({
    url: '/sysUser/updatePassword',
    method: 'put',
    data
  })
}
